/* @flow */

import type { MemberTransactionData } from "shop-state/types";

import React, { useContext } from "react";
import cn from "classnames";
import { StoreInfoContext } from "entrypoint/shared";
import { timestampToDateString } from "helpers/locale-utils";
import Points from "components/AccountView/TransactionsView/Points";
import Spinner from "components/Spinner";
import { useTranslate } from "@awardit/react-use-translate";

import styles from "./styles.scss";

type TableLargeProps = {
  data: MemberTransactionData,
};

const TableLargeHead = () => {
  const { content: { transactionsview } } = useContext(StoreInfoContext);

  return (
    <thead>
      <tr>
        <th>{transactionsview.tableId}</th>
        <th>{transactionsview.tableTransaction}</th>
        {Boolean(!transactionsview.hideTransactionSource) && <th>{transactionsview.tableClub}</th>}
        {Boolean(!transactionsview.hidePoints) && <th>{transactionsview.tablePoints}</th>}
        {Boolean(transactionsview.showRankpts) && <th>{transactionsview.tableRankpts}</th>}
        <th>{transactionsview.tableDate}</th>
        {Boolean(!transactionsview.hidePointsExpires) &&
          <th>{transactionsview.tablePointsExpires}</th>}
      </tr>
    </thead>
  );
};

const TableLarge = ({ data }: TableLargeProps): React$Node => {
  const { content: { transactionsview } } = useContext(StoreInfoContext);
  const t = useTranslate();

  return (
    <div className={styles.tableLarge}>
      <table className={styles.table}>
        <TableLargeHead />
        <tbody>
          {data.transactions.map(x => (
            <tr key={x.id}>
              <td>{x.id}</td>
              <td>{x.type === 471 ? `${t("TRANSACTIONS.REFUND")} ${x.description}` : x.description}</td>
              {Boolean(!transactionsview.hideTransactionSource) && <td>{x.club}</td>}
              {Boolean(!transactionsview.hidePoints) &&
                <td className={cn({ [styles.negative]: x.flag === "DOWN" })}>
                  {x.flag === "DOWN" && x.points > 0 ? "-" : ""}<Points points={x.points} />
                </td>
              }
              {Boolean(transactionsview.showRankpts) &&
                <td className={cn({ [styles.negative]: x.flag === "DOWN" })}>
                  {x.flag === "DOWN" && x.rank > 0 ? "-" : ""}<Points points={x.rank} />
                </td>
              }
              <td>{timestampToDateString(x.date)}</td>
              {Boolean(!transactionsview.hidePointsExpires) &&
                <td>
                  {x.expiresAt !== null &&
                  timestampToDateString(x.expiresAt)}
                </td>
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const TableLargeHint = (): React$Node => (
  <div className={cn(styles.tableHint, styles.tableHintLarge)}>
    <Spinner />
  </div>
);

export default TableLarge;
